//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'wrap',
        data() {
            return {
                isGb:true
            }
        },
        created() {
            let gb = localStorage.getItem('gb');
            if(gb == 1){
                this.isGb=false
            }else{
               this.isGb=true
            }
        },
        methods:{
           goBz(){
               this.$router.push('/direction')
               localStorage.setItem('gb','1');
               this.isGb = false
           },
           gb(){
               localStorage.setItem('gb','1');
               this.isGb = false
           }
        }
    }



// WEBPACK FOOTER //
// ./src/App.vue